module.exports = __webpack_public_path__ + "static/media/VRED Mixed Reality.9bf0385b.png";